import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=507cfce9&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=507cfce9&prod&lang=scss&"
import style1 from "./Header.vue?vue&type=style&index=1&id=507cfce9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cfce9",
  null
  
)

export default component.exports